/* eslint-disable no-mixed-spaces-and-tabs */

/* global sfclient */

import React, { Component } from 'react'
import { connect } from 'react-redux'

import { newMeetingReceived, chatClosed, chatRemoved, chatJoined } from './live_chats_reducer'
import { getApiToken, logoutSuccess, chatUserFetched } from '../user'
import * as Constants from '../../helpers/constants'
import { Notify } from '../notifications'
import { isMeetingJoined } from './live_chats_reducer'
import { live_visitors } from '../visitors'

class Chat extends Component {

  constructor(props) {
    super(props)
    this.chatUserTryCount = 0
    this.chatLoadTryCount = 0
    this.chatUserCreated = null
    this.chatUser = null
    this.baseApiUrl = null
  }

  componentWillUnmount() {
    sfclient.chat.clearSession()
		
  }

  componentDidMount() {
    this.getChatUser()
    if (window) {
      if (!window.sfcrmdashboard) {
        window.sfcrmdashboard = []
      }
      window.sfcrmdashboard["chat"] = this
    } else {
      console.log("Error: window object not found, app not running in brwoser environment")
    }
  }

	getChatUser = () => {

	  let self = this

	  let chatUserUrl = APP_API_URL + 'api/v1/user/createchatuser'
	  let apiToken = this.props.dispatch(getApiToken())

	  if (!apiToken && this.chatUserTryCount < 3) {
	    setTimeout(function () {
	      self.getChatUser()
	    }, 3000)
	    this.chatUserTryCount = this.chatUserTryCount + 1
	    return
	  }

	  fetch(chatUserUrl, {
	    headers: {
	      'Accept': 'application/json',
	      'Content-Type': 'application/json',
	      'Authorization': apiToken,
	      'X-Crm-App-Version': APP_VERSION
	    },
	    method: 'GET'
	  })
	    .then((response) => {
	      if (response.status === 200) {
	        return response.json()
	      } else if (response.status === 401) {
	        self.props.dispatch(logoutSuccess())
	      }
	    })
	    .then((res) => {
	      // self.initialization(res.data)
	      self.chatUser = res.data
	      self.getChatSession(res.data)
	    })
	    // eslint-disable-next-line no-unused-vars
	    .catch((err) => {
	    })
	}

	getChatSession = (data) => {
	  let self = this

	  fetch(data.url, {
	    headers: {
	      'Accept': 'application/json',
	      'Content-Type': 'application/json',
	      'Authorization': data.token
	    },
	    method: 'POST'
	  })
	    .then((response) => {
	      if (response.status === 200) {
	        return response.json()
	      } else if (response.status === 401) {
	        self.props.dispatch(logoutSuccess())
	      }
	    })
	    .then((res) => {
	      // self.initialization(res.data)
	      self.chatUser.token = res.data.token
	      self.chatUser.offline_packet = res.data.offline_packet
	      self.chatUser.online_packet = res.data.online_packet
	      self.chatUser.session_id = res.data.session_id
	      self.chatUser.session_detail_id = res.data.session_detail_id
	      self.chatUser.name = res.data.name
	      self.baseApiUrl = res.data.base_api_url
	      self.initialization()
	    })
	    // eslint-disable-next-line no-unused-vars
	    .catch((err) => {
	    })

	}

	initialization() {
	  let options = {
	    user: this.chatUser,
	    onNewMeetingReceivedCallback: this.onNewMeetingReceived,
	    onMeetingClosedCallback: this.onMeetingClosed,
	    onMeetingLeftCallback: this.onMeetingLeft,
	    onMeetingEndedCallback: this.onMeetingEnded,
	    onMeetingUserInviteCallback: this.onMeetingUserInvite,
	    onNewVisitorArrivedCallback: this.onNewVisitorArrived,
	    onSystemInviteCallback: this.onSystemInvite,
	    onUserActivityCallback: this.onUserActivity,
	    onNetworkStatusChangeCallback: this.onNetworkStatusChange,
	    onMeetingJoinedCallback: this.onMeetingJoined,
	    baseApiUrl: this.baseApiUrl
	  }

	  if (sfclient) {
	    sfclient.onReady(options)
	      // eslint-disable-next-line no-unused-vars
	      .then(data => {
	        this.loadChat()
	      })
	  } else {
	    alert("sfclient not ready")
	  }
	}

	onUserActivity = (data) => {
	  if (live_visitors()) {
	    live_visitors().addNewVisitor(data)
	  }
	}

	onNetworkStatusChange = (data) => {
	  if (data.profile_type === "agent") {
	    if (this.chatUser.id !== data.user_id) {
	      sfclient.chat.contactNetworkStatusChange(data)
	    }
	  } else if (data.profile_type === "guest") {
	    sfclient.chat.updateVisitorNetworkStatus(data)
	  }
	}

	onMeetingJoined = (data) => {
	  if (data.profile_id !== this.props.user.chatUserId) {
	    this.props.dispatch(chatRemoved(data.meeting_id))
	  }
	  Notify().removeNotification('newmeeting:' + data.meeting_id)
	}

	onNewMeetingReceived = (data) => {
	  this.props.dispatch(newMeetingReceived(data))
	  this.newMeetingNotification(data)
	}

	onMeetingClosed = (meetingId) => {
	  this.props.dispatch(chatClosed(meetingId))
	}

	onMeetingLeft = (data) => {
	  if (data.status === Constants.SF_API.Success) {
	    this.props.dispatch(chatClosed(data.data.id))
	    this.props.dispatch(chatRemoved(data.data.id))
	  } else {
	    this.leaveMeetingFailedNotification(data)
	  }

	}

	onMeetingEnded = (meeting_id) => {
	  this.props.dispatch(chatClosed(meeting_id))
	  this.props.dispatch(chatRemoved(meeting_id))
	  let notificationDetails = {
	    title: 'Meeting Ended',
	    message: 'Meeting ' + meeting_id + ' was ended.',
	    level: 'warning',
	    uid: "meeting-ended-" + meeting_id
	  }
	  Notify().showNotification(notificationDetails)
	}

	onMeetingUserInvite = (data) => {
	  this.props.dispatch(newMeetingReceived(data.meeting_details))
	  this.inviteMeetingNotification(data.meeting_details)
	}

	// eslint-disable-next-line no-unused-vars
	onNewVisitorArrived = (data) => {
	}

	onSystemInvite = (data) => {
	  let chatAlreadyJoined = this.props.dispatch(isMeetingJoined(data.id))
	  if (chatAlreadyJoined) {
	    this.systemInviteAcknowledge(data.acknowledge_api.url, data.notification_id)
	  } else {
	    this.systemInviteNotification(data.id, data.join_api.url, data.join_api.payload)
	  }
	}

	systemInviteAcknowledge = (ack_url, notification_id) => {
	  let body = {
	    notification_id: notification_id
	  }
	  sfclient.chat.systemInviteAcknowledge(ack_url, body)
	    .then(function (res) {
	      // eslint-disable-next-line no-empty
	      if (res.status === Constants.SF_API.Success) {
	      }
	    })
	}

	systemInviteNotification = (id, join_url, options) => {
	  let notificationDetails = {
	    title: "Meeting Reinitiated",
	    message: 'Meeting ' + id + ' has been re-initiated ',
	    level: "info",
	    instance: this,
	    uid: "invite:" + id,
	    actionLabel: "Join",
	    actionCallback: this.systemInviteJoin.bind(this),
	    callbackParameters: {
	      url: join_url,
	      options: options
	    }
	  }

	  Notify().showNotification(notificationDetails)
	}

	leaveMeetingFailedNotification = (data) => {
	  let notificationDetails = {
	    title: "Leave meeting failed",
	    message: data.reason,
	    level: "warning",
	    uid: "leave_meeting_failed:",
	  }

	  Notify().showNotification(notificationDetails)
	}

	systemInviteJoin = (params) => {
	  let self = this
	  sfclient.chat.systemInviteJoin(params.url, params.options)
	    .then(function (res) {
	      if (res.status === Constants.SF_API.Success) {
	        self.props.dispatch(chatJoined(res.data.meeting_details))
	      } else {
	        self.joinMeetingFailedNotification(res)
	      }
	    })
	}

	joinMeetingFailedNotification = (data) => {
	  let notificationDetails = {
	    title: "Join meeting failed",
	    message: data.reason,
	    level: "warning",
	    uid: "join-meeting-failed",
	  }

	  Notify().showNotification(notificationDetails)
	}

	loadChat(displayMode = 'DISPLAYMODE_ICON', notificationId) {
	  var chatConfig = {
	    visitor: { name: "Guest", initialMessage: "Hello" },
	    style: {
	      position: "right-bottom",
	      skinName: "blue"
	    },
	    container: "chat-container",
	    custom_data: { "client_user_id": "H243-AS2", "client_user_name": "my-user-name" },
	    user_type: "client",		//User type should be client or agent
	    display_mode: displayMode,      //DISPLAYMODE_NORMAL, DISPLAYMODE_ICON,
	    //DISPLAYMODE_FULLSCREEN, DISPLAYMODE_MINIMIZED, DISPLAYMODE_HIDE.      
	    show_header: true,               //true or false
	    show_body: true,                 //true or false
	    show_footer: true,               //true or false
	    user_join_leave_event: true,    //true or false
	    mask_user_typing_text: true,    //true or false
	    width: "320px",
	    height: "350px",
	    notification_id: notificationId,
	  };

	  if (sfclient) {
	    sfclient.chat.loadAgentChat(chatConfig)
	    // sfclient.chat.joinMeetingRequest(1)
	  } else {
	    alert("BnJsLib not ready")
	  }

	  this.props.dispatch(chatUserFetched(this.chatUser.id))
	}

	newMeetingNotification(payloadData) {
	  let notificationDetails = {
	    title: "New Meeting",
	    message: "Meeting " + payloadData.id + " has been received",
	    level: "success",
	    instance: this,
	    uid: "newmeeting:" + payloadData.id,
	    actionLabel: "Accept",
	    actionCallback: this.onMeetingAccept.bind(this),
	    callbackParameters: {
	      meetingId: payloadData.id
	    }
	  }

	  Notify().showNotification(notificationDetails)
	}

	inviteMeetingNotification(payloadData) {

	  // let invitedAgent = this.invocationContext.props.dispatch(getContactDetails(payloadData.invited_by))
	  let notificationDetails = {
	    title: "Meeting Invitation",
	    message: 'Agent ' + payloadData.invitee_name + ' has invited you to meeting ' + payloadData.id,
	    level: "info",
	    instance: this,
	    uid: "invite:" + payloadData.id,
	    actionLabel: "Join",
	    actionCallback: this.onMeetingAccept.bind(this),
	    callbackParameters: {
	      meetingId: payloadData.id
	    }
	  }

	  Notify().showNotification(notificationDetails)
	}

	onMeetingAccept = (params) => {
	  let chatAlreadyJoined = this.props.dispatch(isMeetingJoined(params.meetingId))
	  if (!chatAlreadyJoined) {
	    let self = this
	    sfclient.chat.joinMeetingRequest(params.meetingId)
	      .then(function (res) {
	        if (res.status === Constants.SF_API.Success) {
	          self.props.dispatch(chatJoined(res.data.meeting_details))
	        }
	      })
	  }
	}

	render() {
	  return (
	    <div id="chat-container" className="container side-chat"></div>
	  )
	}
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer,
  }
}

export function ChatInstance() {
  return window.sfcrmdashboard["chat"]
}

export default connect(mapStateToProps)(Chat)


// WEBPACK FOOTER //
// ./src/components/chats/chat.js